import { render, staticRenderFns } from "./MovieDatabase.vue?vue&type=template&id=8f86c52a&scoped=true&"
import script from "./MovieDatabase.vue?vue&type=script&lang=js&"
export * from "./MovieDatabase.vue?vue&type=script&lang=js&"
import style0 from "./MovieDatabase.vue?vue&type=style&index=0&id=8f86c52a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f86c52a",
  null
  
)

export default component.exports